import styled, { css } from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const TextSection = styled.div`
  z-index: 50;
  max-width: 470px;
`;

export const ButtonSection = styled.div`
  z-index: 50;
`;

export const SolidColorBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${({ theme }) => theme.tertiaryColour};
  opacity: 0.8;
`;

export const Summary = styled.div`
  letter-spacing: 1.92px;
`;

export const StyledHero = styled.div<{
  isCompact?: boolean;
}>`
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  color: #fff;
  padding: 20px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.5);

  ${media.lg`
    justify-content: center;
  `}

  ${({ isCompact }) =>
    isCompact
      ? css`
          ${media.lg`
      min-height: 290px;
    `}
        `
      : css`
          ${media.lg`
      min-height: 600px;
    `}
        `}
`;
